import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: null,
};

const scrollSlice = createSlice({
  name: 'scroll',
  initialState,
  reducers: {
    setScrollState: (state, { payload }) => (
      {
        ...state,
        status: payload.status,
      }
    ),
  },
});

export const {
  setScrollState,
} = scrollSlice.actions;
export default scrollSlice.reducer;
